export default __webpack_public_path__ + "static/media/UNMIL_disarmament_and_rehabilitation.aa6db543.jpg";